import { createSelector } from "reselect"
import { get, chain } from "lodash"
import { getEarliestDate } from "modules/portfolio-root/selectors/dates"
import { getPerformanceFetchStartDate } from "selectors/dates"
import { getMustAggregateFactors } from "modules/portfolio-root/selectors/portfolios"
import { getModelFactorsClassification } from "selectors/modelMetadata"
import { aggregateFactorsSumBy } from "helpers/factorClassification/index"
import { mapPerformanceFactorsReturnsToValue } from "helpers/contributors"
import moment from "moment"

const getRawPerformanceFactors = state => get(state, "global.data.axiomaPerformanceDetails.data.model.simulation.performance[0].attribution.factors")

const getPerformance = createSelector(
  [getRawPerformanceFactors],
  factors => mapPerformanceFactorsReturnsToValue(factors, "cumulativePercent"),
)

export const getPerformanceDetails = createSelector(
  [getPerformance, getMustAggregateFactors, getModelFactorsClassification],
  (performance, mustAggregateFactors, factorsClassification) => {
    let factors = performance
    if (mustAggregateFactors) {
      factors = aggregateFactorsSumBy(factorsClassification, factors, "value")
    }
    return chain(factors)
      .keyBy("id")
      .mapValues(item => ({ pnl: item.value }))
      .value()
  },
)

export const getFactorsPerfStartDate = createSelector(
  [getEarliestDate, getPerformanceFetchStartDate],
  (earliestDate, startDate) => startDate === earliestDate ? moment(startDate).add(1, "day").format("YYYY-MM-DD") : startDate,
)
